// extracted by mini-css-extract-plugin
export default {"fullWidth":"Nm-z","image":"Om-z","lazyLoadPicture":"Pm-z","lazyLoadSpinner":"Qm-z","lazyLoadSpin":"Rm-z","lazyLoadImage":"Sm-z","hasStyledAspectRatio":"Tm-z"};